import { HotelDetailFeatureItemViewModel } from '@api/index';
import { HotelDetailImageViewModel, HotelPromotionViewModel } from '@api/v3';
import { Amenity } from '@components/cards/amenity/AmenityCard';
import { Promotions } from '@components/cards/opportunity/OpportunityCard';
import { Images } from '@components/galleries/GalleryHeroImages/GalleryHeroImages';

export const formatAmenities = (
  amenities?: HotelDetailFeatureItemViewModel[]
): Amenity[] =>
  amenities?.map((amenity) => ({
    id: amenity.id,
    title: amenity.name || '',
    icon: amenity.featureIcon || '',
  })) || [];

export const formatHotelPromotions = (
  hotelPromotions?: HotelPromotionViewModel[]
): Promotions[] =>
  hotelPromotions?.map((item) => ({
    name: item.name || '',
    description: item.description || '',
    image: item.image || '/static/images/setur-static.jpg',
  })) || [];

export const formatHotelImages = (
  images?: HotelDetailImageViewModel[],
  name?: string
): Images[] =>
  images?.map((image, index) => ({
    url: image?.url || '/static/images/setur-static.jpg',
    alt: `${name} ${image.hotelImageCategoryName} ${index + 1}`,
  })) || [];
